/* eslint-disable @tooling/bp-linting/color-no-hardcoded */
"use client";
import { Typography } from "@shared/ui.primitives";
import { colours } from "@shared/ui.design-system";
import { useFindation, type FindationProps } from "./useFindation";
import { withErrorBoundary } from "react-error-boundary";
import { Logger } from "@shared/utils.logger";
import { findationButtonContainer } from "./FindationWidget.css";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import { track } from "tracking";

// Foundation shade colors
const shadeColours = {
  light: "#EDBF9F",
  medium: "#CFA06C",
  dark: "#643C23"
} as const;

function FindationWidgetComponent(props: FindationProps) {
  const { showButton, findation } = useFindation(props);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.9
  });

  useEffect(() => {
    if (inView && showButton) {
      track({
        event: "Page Element Viewed",
        properties: {
          location_type: "shade_matcher",
          module_content: "shade_matcher_btn",
          module_content2: "findMyShade"
        }
      });
    }
  }, [inView, showButton]);

  return (
    <>
      {showButton && findation?.openWidget && (
        <div
          className={findationButtonContainer}
          onClick={() => findation?.openWidget?.()}
          ref={ref}
        >
          <Typography variant="link-xs">Find my shade</Typography>
          <svg
            width="41"
            height="17"
            viewBox="0 0 41 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8.5"
              cy="8.5"
              r="8"
              fill={shadeColours.light}
              stroke={colours.secondary.light}
            />
            <circle
              cx="20.5"
              cy="8.5"
              r="8"
              fill={shadeColours.medium}
              stroke={colours.secondary.light}
            />
            <circle
              cx="32.5"
              cy="8.5"
              r="8"
              fill={shadeColours.dark}
              stroke={colours.secondary.light}
            />
          </svg>
        </div>
      )}
    </>
  );
}

export const FindationWidget = withErrorBoundary(FindationWidgetComponent, {
  fallback: null,
  onError(error) {
    Logger.warn(`FindationWidget unexpected error. ${error}`);
  }
});
